/* Sol Calypso product page.

   Lifted out of sections/sc-product.liquid, which had grown past the size
   where it could be rewritten in one payload. The values that came from
   settings arrive as data attributes on the root instead. */
(function () {
  var root = document.querySelector('.sc-pd');
  if (!root || root.dataset.bound === '1') return;
  root.dataset.bound = '1';

  var LABELS = {
    add: root.getAttribute('data-add-label') || 'Add to bag',
    soldOut: root.getAttribute('data-sold-label') || 'Sold out',
    save: root.getAttribute('data-save-label') || 'Save',
    off: root.getAttribute('data-off-label') || 'off'
  };
  var CURRENCY = root.getAttribute('data-currency') || 'EUR';

  /* ---------- gallery ----------
     Only the carousel needs any of this, and on a phone that is both layouts.
     In the desktop grid the arrows and dots are hidden by CSS, and the track
     is not a scroller, so the handlers below simply never do anything. */
  var track = root.querySelector('[data-sc-track]');
  var dots = root.querySelectorAll('[data-sc-dot]');
  if (track && dots.length) {
    var slides = track.querySelectorAll('.sc-pd__slide');
    var index = function () { return Math.round(track.scrollLeft / track.clientWidth); };
    var go = function (i) {
      var n = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' });
    };
    var paint = function () {
      var i = index();
      dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
    };
    var prev = root.querySelector('[data-sc-prev]');
    var next = root.querySelector('[data-sc-next]');
    if (prev) prev.addEventListener('click', function () { go(index() - 1); });
    if (next) next.addEventListener('click', function () { go(index() + 1); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-sc-dot'), 10)); }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(paint); });
    paint();
  }

  /* ---------- read more ----------
     The button is rendered hidden and only revealed once the text is measured
     as actually overflowing its clamp. A "Read more" over three lines that
     were never cut is worse than no button at all, and how many lines fit
     depends on the column width, so it cannot be decided in Liquid.

     Measured again on resize and whenever a row is opened, but only while
     collapsed - re-running it on an expanded description would fold it back
     up under the reader. */
  var desc = root.querySelector('[data-sc-desc]');
  var more = root.querySelector('[data-sc-more]');
  if (desc && more) {
    var measure = function () {
      if (!desc.classList.contains('is-clamped')) return;
      /* A closed <details> reports zero height, which would read as "fits"
         and hide the button for good. */
      if (desc.clientHeight === 0) return;
      more.hidden = desc.scrollHeight - desc.clientHeight <= 2;
    };

    desc.classList.add('is-clamped');
    measure();

    more.addEventListener('click', function () {
      var clamped = desc.classList.toggle('is-clamped');
      more.setAttribute('aria-expanded', clamped ? 'false' : 'true');
      more.textContent = clamped
        ? more.getAttribute('data-more')
        : more.getAttribute('data-less');
    });

    window.addEventListener('resize', measure);
    root.querySelectorAll('.sc-pd__row').forEach(function (row) {
      row.addEventListener('toggle', measure);
    });
  }

  /* ---------- variants ---------- */
  var raw = root.querySelector('[data-sc-variants]');
  var variants = [];
  try { variants = JSON.parse(raw.textContent); } catch (e) {}

  var vidInput = root.querySelector('[data-sc-vid]');
  var priceEl = root.querySelector('[data-sc-price]');
  var wasEl = root.querySelector('[data-sc-was]');
  var saveEl = root.querySelector('[data-sc-save]');
  var stickyPrice = root.querySelector('[data-sc-stickyprice]');
  var stickyWas = root.querySelector('[data-sc-stickywas]');
  var stickyOff = root.querySelector('[data-sc-stickyoff]');
  var addBtn = root.querySelector('[data-sc-add]');
  var addLabel = root.querySelector('[data-sc-addlabel]');
  var expressBtn = root.querySelector('[data-sc-express]');
  var qtyInput = root.querySelector('[data-sc-qty]');

  var money;
  try {
    money = new Intl.NumberFormat(document.documentElement.lang || undefined, {
      style: 'currency', currency: CURRENCY
    });
  } catch (e) { money = null; }
  function fmt(cents) {
    var n = cents / 100;
    return money ? money.format(n) : n.toFixed(2);
  }

  /* One place decides how many are going in the bag, so the stepper, the
     inline button and the sticky bar can never disagree. */
  function qty() {
    var n = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    if (!n || n < 1) n = 1;
    return n;
  }

  root.querySelectorAll('[data-sc-qtystep]').forEach(function (b) {
    b.addEventListener('click', function () {
      var step = parseInt(b.getAttribute('data-sc-qtystep'), 10);
      var n = qty() + step;
      if (n < 1) n = 1;
      if (qtyInput) qtyInput.value = n;
    });
  });

  function chosen() {
    return [].slice.call(root.querySelectorAll('[data-sc-opt]')).map(function (g) {
      var on = g.querySelector('.sc-pd__pill.is-on');
      return on ? on.getAttribute('data-sc-val') : null;
    });
  }

  function resolve() {
    var want = chosen();
    if (!want.length) return variants[0];
    return variants.filter(function (vr) {
      return want.every(function (val, i) { return val === null || vr.options[i] === val; });
    })[0];
  }

  function apply() {
    var vr = resolve();
    if (!vr) return;
    var onSale = !!(vr.compare_at_price && vr.compare_at_price > vr.price);
    var pct = onSale ? Math.round((vr.compare_at_price - vr.price) / vr.compare_at_price * 100) : 0;

    if (vidInput) vidInput.value = vr.id;
    if (priceEl) {
      priceEl.textContent = fmt(vr.price);
      priceEl.classList.toggle('is-sale', onSale);
    }
    if (wasEl) {
      if (onSale) { wasEl.textContent = fmt(vr.compare_at_price); wasEl.hidden = false; }
      else { wasEl.hidden = true; }
    }
    /* Worked out from the variant rather than written down, so a price change
       in the admin can never leave a stale percentage on the page. */
    if (saveEl) {
      if (onSale) { saveEl.textContent = LABELS.save + ' ' + pct + '%'; saveEl.hidden = false; }
      else { saveEl.hidden = true; }
    }

    /* The sticky bar carries the same three parts as the price line, so it
       has to be told about all three, not just the current price. */
    if (stickyPrice) stickyPrice.textContent = fmt(vr.price);
    if (stickyWas) {
      if (onSale) { stickyWas.textContent = fmt(vr.compare_at_price); stickyWas.hidden = false; }
      else { stickyWas.hidden = true; }
    }
    if (stickyOff) {
      if (onSale) { stickyOff.textContent = '(' + pct + '% ' + LABELS.off + ')'; stickyOff.hidden = false; }
      else { stickyOff.hidden = true; }
    }

    if (addBtn) addBtn.disabled = !vr.available;
    if (addLabel) addLabel.textContent = vr.available ? LABELS.add : LABELS.soldOut;
    /* The express button carries the same availability as the add button, so
       the greyed-out state is never a route to a checkout that would fail. */
    if (expressBtn) expressBtn.disabled = !vr.available;
  }

  root.querySelectorAll('.sc-pd__pill').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('[data-sc-opt]');
      group.querySelectorAll('.sc-pd__pill').forEach(function (b) {
        b.classList.remove('is-on');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-on');
      /* The chosen size reads as weight and colour alone, so the state has to
         be announced rather than left to the styling. */
      btn.setAttribute('aria-pressed', 'true');
      apply();
    });
  });
  apply();

  /* ---------- add to cart ---------- */
  var form = root.querySelector('[data-sc-form]');
  var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function addToCart(btn) {
    if (!vidInput) return;
    if (btn) btn.disabled = true;
    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(vidInput.value, 10), quantity: qty() }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        return fetch(rootUrl + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        /* Re-publish the storefront standard event so the drawer, the header
           count and anything else already listening all react exactly as they
           do to Horizon's own add-to-cart. */
        var ev = new Event('shopify:cart:lines-update', { bubbles: true });
        ev.action = 'add';
        ev.context = 'product';
        ev.promise = Promise.resolve({ cart: { totalQuantity: cart.item_count } });
        document.dispatchEvent(ev);
      })
      .catch(function () { window.location.href = rootUrl + 'cart'; })
      .then(function () { if (btn) btn.disabled = false; });
  }

  if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(addBtn); });
  var stickyAdd = root.querySelector('[data-sc-stickyadd]');
  if (stickyAdd) stickyAdd.addEventListener('click', function () { addToCart(stickyAdd); });

  /* ---------- express checkout ----------
     The permalink the published theme uses: /cart/<variant>:<qty>?checkout
     builds a one-line cart and goes straight to checkout, leaving whatever is
     already in the bag untouched. */
  if (expressBtn) {
    expressBtn.addEventListener('click', function () {
      if (expressBtn.disabled || !vidInput || !vidInput.value) return;
      window.location.href = rootUrl + 'cart/' + vidInput.value + ':' + qty() + '?checkout';
    });
  }

  /* ---------- sticky bar reveals once the inline button scrolls away ---------- */
  var sticky = root.querySelector('[data-sc-sticky]');
  if (sticky && addBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        /* `!isIntersecting` is true the moment the page loads whenever the
           inline button sits below the fold, which showed the bar straight
           away. It must only appear once the button has been scrolled ABOVE
           the viewport, so test the rect's top instead. */
        var scrolledPast = en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', scrolledPast);
        sticky.setAttribute('aria-hidden', scrolledPast ? 'false' : 'true');
      });
    }, { threshold: 0 }).observe(addBtn);
  }
})();
